import { useMemo } from 'react';
import { useMutation } from '@apollo/client';

import parseValidationErrors from '../../../common/utils/errors/parseValidationErrors';
import useOfflineMutation from '../../offline/useOfflineMutation';

const useCreateMutation = ({ createMutation, offlineConfigKey, disableOffline = false }) => {
	const hook = offlineConfigKey ? useOfflineMutation : useMutation;
	const hookOptions = offlineConfigKey ? { configKey: offlineConfigKey, disableOffline } : {};

	const [mutationFunction, createStatus] = hook(createMutation, hookOptions);

	const createItemFunction = values => {
		return mutationFunction({
			variables: {
				input: {
					...values,
				},
			},
		});
	};

	const validationErrors = useMemo(() => parseValidationErrors(createStatus.error), [createStatus.error]);

	return {
		createItemFunction,
		createStatus: { ...createStatus, validationErrors },
	};
};

export default useCreateMutation;
